import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  root: {
    '& .k-grid': {
      '& td.color-cell': {
        textAlign: 'center',
        '@global': {
          div: {
            display: 'inline-block',
            width: 40,
            height: 25,
            marginTop: 5,
            cursor: 'default'
          }
        }
      }
    },
    '& .k-pager-wrap .k-link, .k-pager-wrap .k-pager-nav': {
      backgroundColor: 'inherit'
    },
    '& h4': {
      fontSize: '1rem',
      color: theme.card.header.color,
      fontWeight: theme.card.header.fontWeight,
      '&.no-go-back': {
        paddingTop: 10
      }
    },
    '&.is-trash': {
      '& h4.can-go-back': {
        paddingTop: 4
      }
    },
    border: theme.card.border,
    borderBottomWidth: theme.card.borderBottomWidth,
    '& div.card-header': {
      backgroundColor: theme.card.header.backgroundColor,
      minHeight: 71
    }
  },
  buttons: {
    marginBottom: 10
  },
  body: {
    '&': {
      '@global': {
        label: {
          fontSize: 12,
          fontWeight: 'bold'
        }
      }
    }
  },
  warning: {
    position: 'relative',
    display: 'inline-block',
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    marginLeft: theme.spacing(1),
    color: theme.palette.secondary.main,
    fontSize: 14,
    backgroundColor: 'yellow',
    height: 26,
    borderRadius: 15
  },
  text: {
    position: 'relative',
    top: 3
  }
}))

export {
  useStyles
}